/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Faq_4_AInputs */

const en_mk_pricing_faq_4_a = /** @type {(inputs: Mk_Pricing_Faq_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. You pay for people, not for agents. Agent work is bounded by your plan’s task quota, and that quota grows with the number of seats.`)
};

const id_mk_pricing_faq_4_a = /** @type {(inputs: Mk_Pricing_Faq_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak. Anda membayar untuk orang, bukan untuk agen. Kerja agen dibatasi oleh kuota tugas di paket Anda, dan kuota itu naik seiring jumlah kursi.`)
};

/**
* | output |
* | --- |
* | "No. You pay for people, not for agents. Agent work is bounded by your plan’s task quota, and that quota grows with the number of seats." |
*
* @param {Mk_Pricing_Faq_4_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_faq_4_a = /** @type {((inputs?: Mk_Pricing_Faq_4_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Faq_4_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_faq_4_a(inputs)
	return en_mk_pricing_faq_4_a(inputs)
});